module.exports = __webpack_public_path__ + "static/blog-img1-32f134179c6698c2f899b3dae0f100b4.jpg";